var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "combust") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Home_Claro",
    transform: "translate(-161.000000, -4120.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 1.2475008
  }, /*#__PURE__*/React.createElement("g", {
    id: "item_stock_1-copy-26",
    transform: "translate(15.846154, 3875.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(59.010989, 243.640000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(87.432916, 0.010397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "combust",
    transform: "translate(0.000000, 2.071173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.02953057 C0,0.676510189 0.828440672,0 1.85471788,0 L6.80063221,0 C7.82690942,0 8.65535009,0.676510189 8.65535009,2.02953057 L8.65535009,13.5302038 L0,13.5302038 L0,2.02953057 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63834168,5.41207119 C6.28131052,5.41207119 6.80681357,5.0738165 6.80681357,4.13346734 L6.80681357,3.3013627 C6.80681357,2.36101355 6.28131052,2.02275886 5.63834168,2.02275886 L3.02318976,2.02275886 C2.38022092,2.02275886 1.85471788,2.36101355 1.85471788,3.3013627 L1.85471788,4.13346734 C1.85471788,5.0738165 2.38022092,5.41207119 3.02318976,5.41207119 L5.63834168,5.41207119 Z M1.85471788,7.44161208 L3.70943575,7.44161208",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65535009,9.47790403 L11.4374269,9.47114264 L11.4374269,5.41208151 L10.2009483,4.73557132",
    id: "Vector"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComb);
export default __webpack_public_path__ + "static/media/comb.a8de383f695ec8feda7629628ecf0928.svg";
export { ForwardRef as ReactComponent };